/* import bootstrap */
import 'bootstrap/dist/css/bootstrap.min.css';
import { tooltip } from './plugins/bootstrapTooltip';
/* import bootstrap */

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

import "vue-toastification/dist/index.css";
import Toast from "vue-toastification";

import { spinnerLoader } from './plugins/spinnerLoader';

import helpers from './helpers';

import VueApexCharts from "vue3-apexcharts";

/* Import Froala Editor plugins */
import 'froala-editor/js/plugins.pkgd.min.js';

/* Import Froala Editor css files. */
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';

/* Import Froala Editor component */
import VueFroala from 'vue-froala-wysiwyg';

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(Toast)
app.use(VueFroala)
app.use(VueApexCharts)
app.directive('tooltip', tooltip)

app.provide('$loader', spinnerLoader);
app.use(helpers);

app.mount('#app')
